/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const NEWSLETTER_SERVICE = {getNewsletterEmail};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Newsletter";

/* Services */
//
function getNewsletterEmail(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

